module.exports = __webpack_public_path__ + "static/personal-efc6d9fbcbbb29d4828e92af93f5966e.jpeg";